import { action, createRequestTypes } from './base';

export const memberActionTypes = {
  CREATE_MEMBER: createRequestTypes('CREATE_MEMBER'),
  GET_MEMBERS: createRequestTypes('GET_MEMBERS'),
  UPDATE_MEMBER: createRequestTypes('UPDATE_MEMBER'),
  DELETE_MEMBER: createRequestTypes('DELETE_MEMBER'),
  GET_TENANTS_ROLES: createRequestTypes('GET_TENANTS_ROLES'),
};

class MemberActions {
  /**
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  createMember = (payload, callback) => action(memberActionTypes.CREATE_MEMBER.REQUEST, {
    payload,
    callback,
  })

  /**
   *
   * @param createMemberLoading
   * @return {{type: *}}
   */
  createMemberLoading = (createMemberLoading) => action(memberActionTypes.CREATE_MEMBER.LOADING, {
    createMemberLoading,
  })

  /**
   *
   * @param callback
   * @return {{type: *}}
   */
  getMembers = (callback) => action(memberActionTypes.GET_MEMBERS.REQUEST, {
    callback,
  })

  /**
   *
   * @param getMembersLoading
   * @return {{type: *}}
   */
  getMembersLoading = (getMembersLoading) => action(memberActionTypes.GET_MEMBERS.LOADING, {
    getMembersLoading,
  })

  /**
   *
   * @param members
   * @return {{type: *}}
   */
  getMembersSuccess = (members) => action(memberActionTypes.GET_MEMBERS.SUCCESS, {
    members,
  })

  /**
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  updateMember = (payload, callback) => action(memberActionTypes.UPDATE_MEMBER.REQUEST, {
    payload,
    callback,
  })

  /**
   *
   * @param updateMemberLoading
   * @return {{type: *}}
   */
  updateMemberLoading = (updateMemberLoading) => action(memberActionTypes.UPDATE_MEMBER.LOADING, {
    updateMemberLoading,
  })

  /**
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  deleteMember = (payload, callback) => action(memberActionTypes.DELETE_MEMBER.REQUEST, {
    payload,
    callback,
  })

  /**
   *
   * @param deleteMemberLoading
   * @return {{type: *}}
   */
  deleteMemberLoading = (deleteMemberLoading) => action(memberActionTypes.DELETE_MEMBER.LOADING, {
    deleteMemberLoading,
  })

  /**
   *
   * @param callback
   * @return {{type: *}}
   */
     getTenantsRoles = (callback) => action(memberActionTypes.GET_TENANTS_ROLES.REQUEST, {
       callback,
     })

    /**
     *
     * @param getTenantsRolesLoading
     * @return {{type: *}}
     */
    getTenantsRolesLoading = (getTenantsRolesLoading) => action(memberActionTypes.GET_TENANTS_ROLES.LOADING, {
      getTenantsRolesLoading,
    })

    /**
     *
     * @param tenantsRoles
     * @return {{type: *}}
     */
    getTenantsRolesSuccess = (tenantsRoles) => action(memberActionTypes.GET_TENANTS_ROLES.SUCCESS, {
      tenantsRoles,
    })
}
export default new MemberActions();